import { httpRequest } from "@services/http";
import { Budget } from "@models/budget.model";
import { BudgetSerializer } from "@models/serializers/budgetSerializer";

export class CommandDeleteBudget {
  async run(budgetId: number): Promise<Budget> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/budgets/${budgetId}/`;

    try {
      const response = await httpRequest<any>(url, {
        method: "DELETE",
      });
      return this.deserialize(response);
    } catch (error) {
      console.error(`Failed to delete budget ${budgetId}:`, error);
      throw error;
    }
  }

  deserialize(data: any): Budget {
    return BudgetSerializer.fromJson(data);
  }
}